import { WifiOff } from 'lucide-react';
import { usePwaOnlineStatus } from './usePwaStatus';

/**
 * Persistent banner shown at the top of the viewport while the browser
 * reports `navigator.onLine === false`. Submissions made while offline
 * are queued by the service worker and replayed when the network
 * returns; this banner tells the user that's what will happen.
 */
export function OfflineBanner() {
    const online = usePwaOnlineStatus();
    if (online) return null;

    return (
        <div
            role="status"
            aria-live="polite"
            className="fixed top-0 inset-x-0 z-[9999] bg-amber-500 text-white text-sm font-medium px-4 py-2 flex items-center justify-center gap-2 shadow-md"
        >
            <WifiOff className="w-4 h-4" aria-hidden />
            <span>You&rsquo;re offline. Changes will sync when you reconnect.</span>
        </div>
    );
}
